// Column width constants
export const QUANTITY_COLUMN_WIDTH = 48 + 8; // 8px internal left padding
export const MIN_NAME_COLUMN_SIZE = 240;
export const MIN_COLUMN_SIZE = 140;
export const PRICE_INPUT_WIDTH = 88;
export const MIN_DESCRIPTION_COLUMN_SIZE = MIN_COLUMN_SIZE * 2;
// Header height for scroll position calculations
export const ESTIMATED_HEADER_HEIGHT = 60;
// Section header height for catalog search ("catalog results: N" header)
export const ESTIMATED_SECTION_HEADER_HEIGHT = 48;
export const ESTIMATED_ROW_HEIGHT = 59; // 56px content + 1px divider + 2px row border (top+bottom)
export const NAME_COLUMN_PERCENTAGE = 20;

// Column min/max widths - columns use percentage sizing capped by these values
export const UNIT_COLUMN_MIN_WIDTH = 80;
export const UNIT_COLUMN_MAX_WIDTH = 120;
export const ITEM_CODE_COLUMN_MIN_WIDTH = 100;
export const ITEM_CODE_COLUMN_MAX_WIDTH = 140;
export const PRICE_COLUMN_MIN_WIDTH = 180;
export const PRICE_COLUMN_MAX_WIDTH = 160;
export const PRICE_COLUMN_MAX_WIDTH_WITH_UNIT = 200;
export const GP_PERCENTAGE_MIN_COLUMN_SIZE = 130;
export const GP_PERCENTAGE_COLUMN_MAX_WIDTH = 160;
export const GP_DOLLAR_COLUMN_MIN_WIDTH = 96;
export const GP_DOLLAR_COLUMN_MAX_WIDTH = 120;
export const FULFILLED_COLUMN_MIN_WIDTH = 160;
export const FULFILLED_COLUMN_MAX_WIDTH = 220;
export const DESCRIPTION_COLUMN_MAX_WIDTH = UNIT_COLUMN_MAX_WIDTH * 2;
export const PRICE_EDIT_DISPLAY_COLUMN_MIN_WIDTH = 120;
export const PRICE_EDIT_DISPLAY_COLUMN_MAX_WIDTH = 160;
export const BRAND_COLUMN_MIN_WIDTH = 120;
export const BRAND_COLUMN_MAX_WIDTH = 200;
export const PACK_SIZE_COLUMN_MIN_WIDTH = 120;
export const PACK_SIZE_COLUMN_MAX_WIDTH = 160;
export const NOTES_COLUMN_MIN_WIDTH = 160;
export const NOTES_COLUMN_MAX_WIDTH = 200;

// Key to trigger search from quantity cells
export const SEARCH_TRIGGER_KEY = '/';
